import { render, staticRenderFns } from "./approval.vue?vue&type=template&id=1f20facb&scoped=true"
import script from "./approval.vue?vue&type=script&lang=js"
export * from "./approval.vue?vue&type=script&lang=js"
import style0 from "./approval.vue?vue&type=style&index=0&id=1f20facb&lang=scss&scoped=true"
import style1 from "./approval.vue?vue&type=style&index=1&id=1f20facb&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f20facb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f20facb')) {
      api.createRecord('1f20facb', component.options)
    } else {
      api.reload('1f20facb', component.options)
    }
    module.hot.accept("./approval.vue?vue&type=template&id=1f20facb&scoped=true", function () {
      api.rerender('1f20facb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/examine/approval.vue"
export default component.exports